import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

/**
 *  Validator fields Info:
 *
 * maxlength: { "requiredLength": 500, "actualLength": 812 }
 * max: { "max": 999, "actual": 1000 }
 *
 * 'message' is server side validation error
 * message: { "field": "resultsDate", "message": "This date and time must be after the time that the poll closes", "type": "E" }
 *
 */

@Component({
    selector: 'controlMsg',
    moduleId: module.id,
    templateUrl: './controlMsg.component.html'
})
/**
 * Shows message from control errors field
 * control.errors = {message: message, ...other_errors}
 */
export class ControlMsgComponent implements OnInit {

    @Input() form: FormGroup;   // form control
    @Input() field: string;

    get errorsExt() {
        return this.form['errorsExt'] && this.form['errorsExt'][this.field] ? this.form['errorsExt'][this.field] : [];
    }

    get fieldControl() {
        // calling get for hierarchical field names, e.g. "choices.c1"
        const control = this.form.get(this.field);
        return control;
    }

    ngOnInit() {

    }

    getKeys(map) {
        return map ? Array.from(Object.keys(map)) : [];
    }

}
